import { IExperience } from './api';
import { ClaimPageStepEnum } from './shell';
import { IInitSuccessPayload } from './store';

export enum IframeEventsEnum {
  Init = 'init',
  Navigate = 'navigate',
  SetExperience = 'set_experience',
  Ready = 'ready',
  Ping = 'ping',
}

export type IframeInboundMessage =
  | { type: IframeEventsEnum.Init; payload: { page: ClaimPageStepEnum; data: IInitSuccessPayload } }
  | { type: IframeEventsEnum.Navigate; payload: { step: ClaimPageStepEnum } }
  | { type: IframeEventsEnum.SetExperience; payload: { experience: Partial<IExperience> } }
  | { type: IframeEventsEnum.Ping };
